import React,  { Component } from "react";
import {urlVideo} from "../config";
import VideoBg from "reactjs-videobg"; 
 import postCapa from "../images/postCapa.png"
 
class FullScreenVideo extends Component{

    constructor (props) {
        super(props);

        this.state = {
            videoURL: urlVideo
        }
    }
    
    render () {
        return ( 
            <VideoBg poster={postCapa}> 
                <VideoBg.Source src={this.state.videoURL} type="video/mp4" />
            </VideoBg>
        )
    }
};

export default FullScreenVideo;